export const inViewCallback = (entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            // define the event/property you want to use
            //do something with the element, in our case, add a class
            entry.target.classList.add('inview--visible');
        } else {
            // OPTIONAL, in case you want to do something once the intersection is done
        }
    });
};
